/**
 * ═══════════════════════════════════════════════════════════════════════════
 * PRODUCT CATALOG PAGE - VERSION 5.3.1 DYNAMIC
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * DEUX REFS DE SCROLL — rôles distincts:
 *
 *   pageTopRef  — TÊTE DE L'ENTÊTE (tout premier élément du Layout)
 *     Attaché ici sur le <div ref={pageTopRef}> qui entoure tout le
 *     contenu dynamique, avant les sliders et les grilles.
 *     Passé à DynamicPageRenderer (prop pageTopRef).
 *     DynamicPageRenderer déclenche safeScroll(pageTopRef) via
 *     useEffect([facets, pageId]) → au changement d'URL/catégorie.
 *     → L'utilisateur remonte au tout début du contenu.
 *
 *   gridRef  — HAUT DU COMPOSANT ProductGridPage
 *     Passé à buildSectionPaginationProps({ scrollToRef: gridRef })
 *     ET à DynamicPageRenderer (prop gridRef).
 *     DynamicPageRenderer attache gridRef au <div> wrapper de la
 *     première section INDEPENDENT_SECTION_IDS (ProductGridPage).
 *   
 * PAGINATION PAR SECTION (pageData.__pagination__):
 *   Chaque section indépendante a son propre skip.
 *   → Les sections ne se marchent plus dessus.
 * ═══════════════════════════════════════════════════════════════════════════
 */

import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
import { useParams, useLocation } from "react-router-dom";
import Layout from '../Layout/Layout';
import LoadingSwiper from '../slider/loadindSwiper';
import { getCategoriesByID } from '../auth/apiCategory';
import useDataLoader from '../pageInside/exeemple_page/DataLoader';
import DynamicPageRenderer, { buildSectionPaginationProps } from '../pageInside/exeemple_page/DynamicPageRenderer';
import { PAGE_FACETS, getInfoSourceUpdates } from '../pageInside/exeemple_page/allFacets';
import { prices } from "../pageInside/fixedPrices";
import { getProductGridLimit } from '../../utils/paginationSettings';
import { extractConfiguredPage } from '../../utils/infiniteScrollSettings';


// ─────────────────────────────────────────────────────────────────────────────
// _extractFromSettings
// ─────────────────────────────────────────────────────────────────────────────

const _extractFromSettings = (settings) => {
    const resolved = extractConfiguredPage(settings);
    return resolved ? { facets: resolved.facets, configOverrides: resolved.configOverrides } : null;
};

// ─────────────────────────────────────────────────────────────────────────────
// resolvePageConfig — CASCADE STRICTE à 3 niveaux
// ─────────────────────────────────────────────────────────────────────────────

const resolvePageConfig = (pageCategory, pepcSettings, PEPCData) => {
    const level1 = _extractFromSettings(pageCategory);
    if (level1) return level1;

    const level2 = _extractFromSettings(pepcSettings);
    if (level2) return level2;

    const defaultFacets = PAGE_FACETS[PEPCData] || PAGE_FACETS.AAB;
    return { facets: defaultFacets, configOverrides: {} };
};

  const scrollToParagraph = (ref) => {
         if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
      };

// ═══════════════════════════════════════════════════════════════════════════
// COMPOSANT: PRODUCT CATALOG
// ═══════════════════════════════════════════════════════════════════════════

const ProductCatalog = (props) => {
    let params = useParams();
    const { infoSource, laguangeElakay, homeStyles, nbrArr } = props;

    const {pageTopRef} = infoSource; // Expose pageTopRef via infoSource pour scroll au changement d'URL

    const token      = infoSource?.token || null;
    const categoryId = params?.categoryId || props.categoryId;

    const { pathname, state: locationState } = useLocation();
    const previousCategory = locationState?.previousCategory;
useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
       if (categoryId) {
        setMyFilters({
            filters: { "categoriesID.gategoriesLink": [categoryId] }
        });
    }
}, [categoryId, pathname]);
    // ═════════════════════════════════════════════════════════════════════
    // 0. FILTRES + PUB
    // ═════════════════════════════════════════════════════════════════════

    const [myFilters, setMyFilters] = useState({
        filters: { "categoriesID.gategoriesLink": [] },
    });
    const [getpub, setPub] = useState(null);

    const handlePrice = useCallback((value) => {
        // Slider "Customer price" → déjà un [min, max] numérique, pas un _id de palier.
        if (Array.isArray(value)) return value;
        let array = [];
        for (let key in prices) {
            if (prices[key]._id === parseInt(value)) array = prices[key].array;
        }
        return array;
    }, []);

    const handleFilters = useCallback((filters, filterBy) => {
        setMyFilters(prev => {
            const n = { ...prev, filters: { ...prev.filters } };
            n.filters[filterBy] = filterBy === "price" ? handlePrice(filters) : filters;
            return n;
        });
        setSkip(0);
    }, [handlePrice]);

   

    //     const scrollToParagraph = (ref, offset = 0) => {
    //     if (ref && ref.current) {
    //       const element = ref.current;
    //       const elementPosition = element.getBoundingClientRect().top;
    //       const offsetPosition = elementPosition + window.pageYOffset - offset;
    
    //       window.scrollTo({
    //         top: offsetPosition,
    //         behavior: "smooth",
    //       });
    //     }
    //   };

          const scrollToParagraph = (ref) => {
         if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
      };


    // ═════════════════════════════════════════════════════════════════════
    // 1. METADATA CATÉGORIE
    // ═════════════════════════════════════════════════════════════════════

    const [CategoriesProd,  setCategoriesProd]  = useState(null);
    const [PEPCData,        setPEPCData]        = useState('AAB');
    const [categoryName,    setCategoryName]    = useState('');
    const [categoryLoading, setCategoryLoading] = useState(true);

    useEffect(() => {
        if (!categoryId) return;
        setCategoryLoading(true);
        setPub(null);
        scrollToParagraph(pageTopRef); // Scroll vers le haut de la page avec un offset pour le header
        getCategoriesByID(categoryId)
            .then(data => {
                if (data && !data.error) {
                    setCategoriesProd(data);
                    setPEPCData(data.cartegory?.PEPCData || 'AAB');
                    setCategoryName(data.cartegory?.name?.[0] || '');
                    setPub(Array.isArray(data.pub) ? data.pub : []);
                    // categoryId dans l'URL peut être le publicId court (ex: "c-aTbY0v")
                    // au lieu du vrai _id Mongo -- le backend résout déjà les deux pour
                    // readCategoryByID, mais categoriesID.gategoriesLink sur les produits
                    // ne contient que de vrais _id. On corrige donc le filtre ici avec le
                    // _id résolu, sinon la grille de produits reste vide.
                    const resolvedCategoryId = data.cartegory?._id;
                    if (resolvedCategoryId) {
                        setMyFilters(prev => ({
                            ...prev,
                            filters: { ...prev.filters, "categoriesID.gategoriesLink": [resolvedCategoryId] }
                        }));
                    }
                }
            })
            .catch(err => console.error('[ProductCatalog] getCategoriesByID error:', err))
            .finally(() => setCategoryLoading(false));
    }, [categoryId]);

    // ═════════════════════════════════════════════════════════════════════
    // 2. SKIP GLOBAL (sections non-indépendantes)
    // ═════════════════════════════════════════════════════════════════════

    const [skip, setSkip] = useState(0);
    // Admin-configurable via AnimationSettings → General → "Pagination &
    // Limites" (productGrids.productGridPage.limit) — same shared bucket as
    // New Products / Best Sellers / Deal of the Day and this page's own
    // product grid (ProductGridPage.jsx), so Main Pages and Category Pages
    // stay coordinated. Falls back to 12 (the previous hardcoded value).
    // Note: this `limit` only feeds this page's own sliders/matrices batch
    // fetch (useDataLoader below) — the actual category product grid
    // (productGrid section, self-loading) resolves its own limit the same
    // way, independently, inside ProductGridPage.jsx.
    const limit = getProductGridLimit(infoSource?.allSettings, 'productGridPage', 12);

    useEffect(() => { setSkip(0); }, [categoryId, PEPCData, limit]);

    // ═════════════════════════════════════════════════════════════════════
    // 3. DEUX REFS DE SCROLL
    // ═════════════════════════════════════════════════════════════════════
    //
    // pageTopRef — TÊTE DE L'ENTÊTE
    //   Attaché au <div ref={pageTopRef}> qui entoure tout le contenu.
    //   C'est le tout premier élément visible du Layout (avant les sliders).
    //   Passé à DynamicPageRenderer prop pageTopRef → scroll au changement URL.
    //
    // gridRef — HAUT DE ProductGridPage
    //   Passé à buildSectionPaginationProps ET à DynamicPageRenderer.
    //   DynamicPageRenderer attache gridRef au <div> wrapper de la
    //   première section INDEPENDENT_SECTION_IDS dans son render.
   

    const gridRef = useRef(null);  // haut de ProductGridPage → pagination

    // ═════════════════════════════════════════════════════════════════════
    // 4. CASCADE
    // ═════════════════════════════════════════════════════════════════════

    const pageCategory = CategoriesProd?.cartegory?.pageCategory || null;
    const pepcSettings = infoSource?.allSettings?.pages?.[PEPCData] || null;

    // categoryId (param d'URL) peut être un publicId court (ex: "c-aTbY0v") au
    // lieu du vrai _id Mongo. Les requêtes produits (categoriesID.gategoriesLink)
    // ont besoin du vrai _id -- on utilise celui déjà résolu par
    // getCategoriesByID une fois disponible, sinon on retombe sur categoryId
    // (correct pour les anciens liens qui utilisaient déjà le vrai _id).
    const resolvedCategoryId = CategoriesProd?.cartegory?._id || categoryId;

    const { facets, configOverrides } = useMemo(
        () => resolvePageConfig(pageCategory, pepcSettings, PEPCData),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [pageCategory, pepcSettings, PEPCData]
    );

    // ═════════════════════════════════════════════════════════════════════
    // 5. DATA LOADER
    // ═════════════════════════════════════════════════════════════════════

    const {
        pageData, setPageData, loading,
        mergePageData, loadPageData, reloadFacets,
    } = useDataLoader({ facets, infoSource, token, categoryId: resolvedCategoryId, skip, limit, filters: myFilters.filters });

    // ═════════════════════════════════════════════════════════════════════
    // 6. SYNC infoSource → pageData
    // ═════════════════════════════════════════════════════════════════════

    useEffect(() => {
        const updates = getInfoSourceUpdates(facets, infoSource);
        if (Object.keys(updates).length > 0) mergePageData(updates);
    }, [infoSource, facets]);

    // ═════════════════════════════════════════════════════════════════════
    // 7. CHARGEMENT
    // ═════════════════════════════════════════════════════════════════════

    useEffect(() => {
        if (!categoryLoading && categoryId) loadPageData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoryId, PEPCData, skip, JSON.stringify(facets), JSON.stringify(myFilters.filters), categoryLoading]);


    // ═════════════════════════════════════════════════════════════════════
    // 10. CONTEXTE CATÉGORIE
    // ═════════════════════════════════════════════════════════════════════

    const categoryContext = useMemo(() => ({
        categoryId, categoryName,
        categoriesPage: CategoriesProd, PEPCData,
    }), [categoryId, categoryName, CategoriesProd, PEPCData]);

    const swiperPage = useMemo(
        () => (categoryId ? { pageType: 'category', categoryId } : false),
        [categoryId]
    );

    // Titres des catégories listées sur cette page, pour le ticker du sous-menu
    const subnavCategoryTitles = useMemo(
        () => (CategoriesProd?.items || [])
            .map((c) => infoSource.getCategoryNames(c)?.name?.[0])
            .filter(Boolean),
        [CategoriesProd, infoSource]
    );

    // ═════════════════════════════════════════════════════════════════════
    // 11. FLAGS
    // ═════════════════════════════════════════════════════════════════════

    const isLoading     = loading || categoryLoading;
    const P1            = (pageData?.siseProduct || 0) > 0;
    const SliderPunShow = !categoryLoading;

infoSource.divRef = gridRef; // Expose gridRef to infoSource for potential use in ProductGridPage or autres sections indépendantes
    // ═════════════════════════════════════════════════════════════════════
    // 12. RENDER
    // ═════════════════════════════════════════════════════════════════════
    //
    // Structure DOM:
    //
    //   <Layout>
    //     <div ref={pageTopRef}>         ← TÊTE DE L'ENTÊTE (1er élément)
    //       <DynamicPageRenderer
    //         pageTopRef={pageTopRef}    ← scroll URL change
    //         gridRef={gridRef}          ← scroll pagination (grille)
    //       >
    //         <SectionRenderer Slider /> ← sections non-indépendantes
    //         <SectionRenderer Matrix />
    //         <div ref={gridRef}>        ← wrapper première section indépendante
    //           <SectionRenderer Grid /> ← ProductGridPage
    //         </div>
    //       </DynamicPageRenderer>
    //     </div>
    //   </Layout>
    return (
        <Layout
            infoSource={infoSource}
            categoriesID={categoryId}
            titleElakay={categoryName || "elakay.com"}
            loading={isLoading}
            prices={prices}
            handleFilters={handleFilters}
            setMyFilters={setMyFilters}
            getpub={getpub}
            SliderPunShow={SliderPunShow}
            AllCategorie = {CategoriesProd }
            P1={true}
            pageTopRef={pageTopRef}
            subnavCategoryTitles={subnavCategoryTitles}
            subnavPreviousCategoryTitle={previousCategory?.title}
            subnavPreviousCategoryLink={previousCategory?.id ? `/product/${previousCategory.id}` : undefined}
            {...infoSource?.allSettings?.layout}
        >
            {/*
             * pageTopRef — TÊTE DE L'ENTÊTE
             * Premier élément du contenu dynamique, avant les sliders.
             * DynamicPageRenderer scrolle vers lui au changement d'URL.
             *
             * gridRef n'est PAS attaché ici — il est attaché par
             * DynamicPageRenderer sur le wrapper de la première section
             * indépendante (ProductGridPage).
             */}
             
            <div style={infoSource.styleNav}>
                <DynamicPageRenderer
                    facets={facets}
                    pageId={PEPCData}
                    pageData={pageData}
                    infoSource={infoSource}
                    laguangeElakay={laguangeElakay}
                    homeStyles={homeStyles}
                    nbrArr={nbrArr}
                    page="ProductCatalog"
                    myFilters={myFilters}
                    categoryContext={categoryContext}
                    // paginationProps={paginationProps}
                    reloadFacets={reloadFacets}
                    configOverrides={configOverrides}
                  
                    gridRef={gridRef}         // haut de ProductGridPage
                    // Dynamic Swipers of THIS category only (the URL id may be
                    // the short publicId -- the API resolves both), never the
                    // AAA/AAB/AAC template shared by other categories.
                    swiperPage={swiperPage}
                />
                {isLoading && !pageData?.products?.length && !pageData?.productsByArrival?.length && (
                    <>
                        <LoadingSwiper myStyles={homeStyles} />
                        <LoadingSwiper myStyles={homeStyles} />
                        <LoadingSwiper myStyles={homeStyles} />
                        <LoadingSwiper myStyles={homeStyles} />
                    </>
                )}
                </div>
        </Layout>
    );
};

export default ProductCatalog;
